import { AsyncPipe, DOCUMENT, Location, NgClass, NgStyle } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  HostListener,
  Inject,
  Optional,
  Renderer2,
  ViewChild,
  signal,
} from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import {
  DocumentData,
  DocumentSnapshot,
  Firestore,
  doc,
  getDoc
} from "@angular/fire/firestore";
import { FormBuilder, FormGroup, FormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatStep, MatStepLabel, MatStepper, MatStepperIcon } from "@angular/material/stepper";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { AuthSyndicateService } from "@core/AuthServices/authSyndicate/auth-syndicate.service";
import { CatchErrorService } from "@core/catch-error.service";
import { CelebrationAnimationService } from "@core/celebration-animation.service";
import { LoadingService } from "@core/loading.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule, ModalController, NavController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Subject, Subscription, from, throwError } from "rxjs";
import {
  auditTime,
  catchError,
  filter,
  shareReplay,
  switchMap,
  take,
  takeUntil,
} from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { CheckoutConfirmationComponent } from "src/app/components/checkout-confirmation/checkout-confirmation.component";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { PaymentService } from "src/app/services/payment.service";
import { VoucherService } from "src/app/services/vouchers.service";
import Swiper from "swiper";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { v4 as uuidv4 } from "uuid";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
import { DayPipe } from "../../../pipe/day";
import { WalletService } from "../../account/account-wallet/wallet.services";
import { RedirectUriComponent } from "../redirect-uri/redirect-uri.component";
import { StorePaymentComponent } from "../store-payment/store-payment.component";
import { StoreRepositoryService } from "../store-repository.service";
import { CheckoutComGatewayService } from "./services/checkout-com-gateway.service";
import { PostPaymentNavigationService } from "./services/post-payment-navigation.service";
import type { CheckoutTryAgainHostContext, PostPaymentHostBridge } from "./services/checkout-try-again-host-context";
import { ConfirmationPromotionsComponent } from "./components/confirmation-promotions/confirmation-promotions.component";
import { PurchaseDetailCardComponent } from "./components/purchase-detail-card/purchase-detail-card.component";
import { UpsellAddonsComponent } from "./components/upsell-addons/upsell-addons.component";
import { VouchersSliderComponent } from "./components/vouchers-slider/vouchers-slider.component";
import { CardOfferPaymentService } from "./services/card-offer-payment.service";
import { VoucherManagementService } from "./services/voucher-management.service";
import { ExitIntentPopup } from "src/app/components/exit-intent-popup/exit-intent-popup";
import { CommonService } from "src/app/services/common/common.service";
import { ToastFacadeService } from "@core/toast-facade.service";
declare var window;

@Component({
  selector: "app-checkout-try-again",
  templateUrl: "./checkout-try-again.component.html",
  styleUrl: "./checkout-try-again.component.scss",
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  providers: [CheckoutComGatewayService, CardOfferPaymentService, VoucherManagementService, PostPaymentNavigationService],
  imports: [
    IonicModule,
    MatStepper,
    MatStep,
    MatStepLabel,
    FormsModule,
    SwiperModule,
    NgClass,
    NgStyle,
    MatStepperIcon,
    MatIcon,
    InProgressAnimationComponent,
    AsyncPipe,
    DisplayCurrencyPipe,
    DayPipe,
    TranslatePipe,
    UpsellAddonsComponent,
    VouchersSliderComponent,
    ConfirmationPromotionsComponent,
    PurchaseDetailCardComponent],
})
export class CheckoutTryAgainComponent {
  @ViewChild("stepper", { static: false }) stepper: MatStepper;
  @ViewChild("iframe", { static: false }) iframe: ElementRef;
  @ViewChild("checkOutIframe", { static: false }) checkOutIframe: ElementRef;
  @ViewChild("timer", { static: false }) timerspan: ElementRef;

  latestDate: Date | null = null;
  showAll = false;
  speed: number;
  public autoSlide: boolean;
  @ViewChild("slider") slider: SwiperComponent;
  journeyId: number;
  seconds!: number;
  expiry_in_minutes!: number;
  expireInMin = 5;
  timeLeft = this.expireInMin * 60;
  displayResponse: Data;
  private subscription!: Subscription;
  selectedCard = "10";
  cardArrlength: number;
  eventbody: Data;
  proceed = true;
  sub = new Subscription();
  spinnerAnimation: boolean;
  progressBar: number;
  selectedCardData: object;
  latestCardData: object;
  storedCards = [];
  failToast: string;
  successToast: string;
  updatedFailureToast: string;
  updatedSuccessToast: string;
  tp1: string;
  tp2: string;
  tp3: string;
  t_id: string;
  prosub_id: string | number;
  cardOfferDetails: Data[] = [];
  currentOfferCard: string;
  other: number | string;
  promotions: Data[] = [];
  processingStates: boolean[] = Array(this.promotions.length).fill(false);
  cardOfferpurchaseDetail = {} as Data;
  activeCardIndex: number[] = [];

  timerOn = true;
  timeOut: boolean;
  storePaymentData: Data;

  firstInput = 5;
  compRef: ComponentRef<RedirectUriComponent>;
  
  offer_link_id;
  firstFormGroup: FormGroup;
  stepperIndex = 0;
  purchaseDetail$ = new BehaviorSubject(null);
  checkout_description: string;
  isPaymentDone = false;
  price;
  responseObject: Data;
  addNewCardInProgress = false;
  doneCheckoutCreation = false;
  pathString;
  payment_status;
  paymentReceived: boolean;
  privateSyndicateTicket$;
  isPaymill = true;
  isSecureTrading = false;
  isCheckoutCom = false;
  isCheckoutComform = true;
  redirectlink: Data;
  checkOutComData: Data;
  showCheckOutComSpinner = false;
  public isButtonDisabled: boolean;
  public upsellList: Data[];
  public upsell_ID: string;
  public paymentOfferID: string;
  public addonAmount: Data[];
  public checkedValues: number[];
  public updatedPrizeValue: number;
  public totalAmount: number;
  public upsellAmount: number;
  public checkedValuesDefaultCurrency: number[];
  public errorMessage: string;
  public token: string;
  public keys: Data;
  public errorStack: string[] = [];
  public language: string;
  private getCheckOutComResponseSubscription: Subscription;
  private generateCheckoutTokenSubscription: Subscription;
  customerPurchaseEncryptedId: Data;
  show_iframe = false;
  callback: string;
  translatedToastMsg;
  translatedToastMsgSignal = signal<Data>([]);
  selectedLanguage: string = CommonVariable.preferredLanguage;
  selectedLanguageSignal = signal<string>(CommonVariable.preferredLanguage);
  minutes: number;
  /* Master card */
  purchaseDetail = {};

  PaReq: string;
  TermUrl: string;
  MD: string;
  cachetoken = "";
  callType = 1;
  sqlAPICallResponse;
  origin = window.location.origin;
  /* Master card */
  preferredCurrency: string = CommonVariable.preferredCurrency;
  preferredCurrencySignal = signal<string>(CommonVariable.preferredCurrency);
  currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  currencySymbolSignal = signal<string>(CommonVariable.defaultCurrencySymbol);
  stepperIframe: MatStepper;
  customOfferCashbackText = "";
  customOfferAwardId = 0;
  customOfferAwardIdSubscription: Subscription;
  receivedData: Data;
  paymentReason = "";
  private cardTokenizedSubject = new Subject<Data>();
  private currentNdc: string;
  private currentNdcSignal = signal<string>("");
  private paymentReceivedFromCP = false;
  private unsubscribeStatusFromCP$: Subject<void> = new Subject<void>();
  private unsubscribeStatusFromPayment$: Subject<void> = new Subject<void>();
  private unsubscribe$ = new Subject<void>();
  private cardTokenizedCalled = false;
  public checkoutFlowReady = false;
  private storeTabUrl = "/mainTabs/tabs/store";
  private checkoutComPtype = "21";
  public fbTokenKey = "fbToken";
  public userIdKey = "userId";
  tokenValidaterSub: Subscription;
  upsellSummaryArray: Data[];
  private paymentHold = false;
  storeSliderOptions1: SwiperOptions = {
    autoplay: false,
    speed: 500,
    spaceBetween: 0,
    slidesPerView: 1.5,
    centerInsufficientSlides: true,
    edgeSwipeThreshold: 4,
    grabCursor: true,
  };
  public discountVouchersStatus = false;
  discountVouchersData: Data[] = [];
  public selectedDiscountValue = 0;
  private selectedDiscountVoucherData: Data | null = null;
  private addCardPaymentStatus = false;
  private expiryCheckInterval!: Subscription;
  public paymentFailRedirectionStatus = false;
  private storeString = "store";
  userData: Data;
  private framesInitRetryCount = 0;
  private framesInitRetryDelay = 5000;
  private framesInitMaxRetry = 3;
  timeoutId: NodeJS.Timeout;
  userId: string;
  paymentMode: string;

  capping_status = false;
  pwaSegmentStatus: string;
  exit_offer_id: number;
  isOneOff = false;
  destroy$ = new Subject<void>();
  offerId: number;
  constructor(
    private firestore: Firestore,
    private walletService: WalletService,
    private changeDetRef: ChangeDetectorRef,
    private navCtrl: NavController,
    private _formBuilder: FormBuilder,
    private paymentService: PaymentService,
    private utilityService: UtilityService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private modalController: ModalController,
    private authService: AuthService,
    public translate: TranslateService,
    private matDialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private catchService: CatchErrorService,
    private celebrationAnimationService: CelebrationAnimationService,
    private storeService: StoreRepositoryService,
    private loadingService: LoadingService,
    private sanitizer: DomSanitizer,
    private GTMSagmentService: GTMSagmentService,
    private mixPanelService: MixpanelService,
    private AuthSyndicateService: AuthSyndicateService,
    private renderer: Renderer2,
    private voucherService: VoucherService,
    @Inject(DOCUMENT) private document: Document,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Data,
    private cdRef: ChangeDetectorRef,
    private checkoutComGatewayService: CheckoutComGatewayService,
    private postPaymentNavigationService: PostPaymentNavigationService,
    private cardOfferPaymentService: CardOfferPaymentService,
    private voucherManagementService: VoucherManagementService,
    private commonService: CommonService,
    private toastFacade: ToastFacadeService,
  ) {
    this.cardTokenizedSubject?.complete();
    this.minutes = 600;
    this.upsellList = [];
    this.addonAmount = [];
    this.upsellSummaryArray = [];
    this.checkedValues = [];
    this.updatedPrizeValue = 0;
    this.checkedValuesDefaultCurrency = [];
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.authService.selectedlanguage$?.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (l) => {
        if (l) {
          this.selectedLanguageSignal.set(l ? l : CommonVariable?.preferredLanguage);
          this.selectedLanguage = this.selectedLanguageSignal();
          translate.use(l ? l : CommonVariable?.preferredLanguage);
        }
      },
      error: (err) => {
        // Handle the error appropriately
        return err;
      },
    });

    this.authService.getConstantsMsg$.pipe(takeUntil(this.unsubscribe$)).subscribe((msg) => {
      this.translatedToastMsgSignal.set(msg?.static_messages_pwa);
      this.translatedToastMsg = this.translatedToastMsgSignal();
    });
    this.authService?.userDetails$.pipe(
      takeUntil(this.unsubscribe$),
      filter((user) => !!user),
      switchMap((user) => {
        this.userData = user;
        this.preferredCurrencySignal.set(user?.preferred_currency ?? CommonVariable.preferredCurrency);
        this.preferredCurrency = this.preferredCurrencySignal();
        return this.authService.getCurrencyList$.pipe(
          takeUntil(this.unsubscribe$)
        );
      })
    ).subscribe((data: Data) => {
      const CurrencyDetails = data?.details?.find((x) => x?.currency_code === this.preferredCurrencySignal());
      this.currencySymbolSignal.set(CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol);
      this.currencySymbol = this.currencySymbolSignal();
    });

    this.timer(this.minutes);
    // Subscribe to voucher management observables to mirror service state on host
    this.voucherManagementService.discountVouchersData$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.discountVouchersData = v));
    this.voucherManagementService.selectedDiscountValue$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => {
      const previousDiscountValue = this.selectedDiscountValue;
      this.selectedDiscountValue = v;
      this.remountCheckoutFlowForDiscountChange(previousDiscountValue, v);
    });
    this.voucherManagementService.selectedDiscountVoucherData$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.selectedDiscountVoucherData = v));
    this.voucherManagementService.discountVouchersStatus$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.discountVouchersStatus = v));
    this.voucherManagementService.addCardPaymentStatus$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((v) => (this.addCardPaymentStatus = v));
    // Initialize card offer payment service with host context and mirror its state
    this.cardOfferPaymentService.init(this as unknown as CheckoutTryAgainHostContext);
    this.cardOfferPaymentService.activeCardIndex$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.activeCardIndex = v));
    this.cardOfferPaymentService.cardOfferDetails$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.cardOfferDetails = v));
    this.cardOfferPaymentService.promotions$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.promotions = v));
    this.cardOfferPaymentService.processingStates$.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => (this.processingStates = v));
    this.storeService.customOfferCashBackText$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (text: string) => {
        this.customOfferCashbackText = text;
      },
      (err) => {
        return err;
      }
    );

    this.customOfferAwardIdSubscription = this.storeService.customOfferAwardId$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (awardId: number) => {
        this.customOfferAwardId = awardId;
      },
      (err) => {
        return err;
      }
    );
    this.paymentService.getCurrentNdcId().pipe(takeUntil(this.unsubscribe$)).subscribe(
      (ndcId) => {
        this.currentNdcSignal.set(ndcId);
        this.currentNdc = this.currentNdcSignal();
      },
      (err) => {
        return err;
      }
    );
    // Subscribe to selected discount observable
    this.voucherManagementService.selectedDiscount$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value) => {
        this.selectedDiscountValue = value || 0;
      });
  }

  @HostListener("window:message", ["$event"])
  onMessage(e): void {
    if (e && e?.data && e?.data?.for === "paymentDone") {
      // To check for active current session or manually login using token
      this.authService.commonUserCheck(() => {
        this.afterNewCardPaymentDone(this.stepperIframe);
      });
    }
  }
  async ngOnInit() {
    this.getPwasegementData();
    await this.authService
      ?.getUid("CheckoutTryAgainComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error: any) => {
        return error;
      });

    this.loadCards();
    this.fetchOrderData();
    this.redirectlink = null;
    const navigation = this.router.getCurrentNavigation();
    this.storePaymentData = navigation?.extras?.state ?? history.state;
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });

    // To decide the page flow based on the redirection from 3DS approval page
    const currentRoute = localStorage.getItem("currentRoute");
    const isPaymentDone = localStorage.getItem("isPaymentDone");
    if (currentRoute && isPaymentDone === "true") {
      localStorage.removeItem("currentRoute");
      localStorage.removeItem("isPaymentDone");
      this.paymentHold = true;
      this.isPaymentDone = false;
      this.addNewCardInProgress = true;
    } else {
      const currentUrl = this.router.url;
      localStorage.setItem("currentRoute", currentUrl);
      localStorage.removeItem("d");
    }

    const qp = this.actRoute.snapshot?.queryParams ?? {};
    this.paymentMode = qp.pt ?? "";
    if (
      this.checkoutComGatewayService.handleCheckoutFlowRedirectReturn(
        this as unknown as CheckoutTryAgainHostContext,
        qp,
        this.actRoute,
      )
    ) {
      return;
    }
    this.actRoute.params.subscribe(
      (d) => {
        const myuuid = uuidv4();
        this.pathString = d?.time ?? myuuid;
        if (!this.pathString || this.userId == "null" || this.userId == null || !this.pathString) return;
        try {
          if (!this.paymentHold) {
            const currentUrl = this.router.url;
            localStorage.setItem("currentRoute", currentUrl);

            this.catchService.isOnline$
              .pipe(
                switchMap((isOnline) => {
                  if (!isOnline) return from(Promise.resolve(null)); // Return an Observable with null if offline

                  const path_id = "At4Vyy58QQ2vknYAhw7T";
                  const dv = { docId: this.pathString };
                  const method = "read";

                  return this.authService.getV2CloudFunction("updatefirestoredoc", {
                    path_id,
                    dv,
                    method,
                  });
                }),
                this.catchService.retryWhen,
                this.catchService.catchOfflineError,
                shareReplay(1)
              )
              .subscribe(
                async (snapshot: DocumentSnapshot<DocumentData>) => {
                  // Check if snapshot exists before calling data()
                  if (!snapshot || !snapshot.exists()) {
                    this.paymentService?.checkOutComPayload$?.subscribe((reqData) => {
                      this.checkOutComData = reqData;
                      this.paymentService?.setcheckOutComDocId({ docId: String(this.pathString) });
                      this.isCheckoutCom = true;
                      this.isSecureTrading = false;
                      this.isPaymill = false;
                    });
                    return;
                  }

                  // Explicitly cast the snapshot's data to the expected type
                  const data = snapshot.data() as {
                    payment_response_checkout?: boolean;
                    checkout_response?: { paymentWidgetUrl?: string };
                  };

                  if (data) {
                    if (data.payment_response_checkout) {
                      this.authService.getConstantsMsg("1052").then((translatedMsg) => {
                        const defaultMsg = {
                          message: {
                            line_1: "Payment session has expired, please try again!",
                            line_2: "",
                          },
                          style: {
                            icon: "tick circle error.svg",
                            type: "Error",
                          },
                        };
                        this.authService.showToastMessage(translatedMsg, defaultMsg);
                      });
                      this.router.navigateByUrl("/mainTabs/tabs/home");
                    } else {
                      this.currentNdc = this.currentNdcSignal();
                      try {
                        await this.unloadPaymentWidget();
                      } catch (error) {
                        this.authService.errorHandlerLogs("Error unloading payment widget:", error);
                        return;
                      }
                      this.utilityService.loadScriptForPayment([data.checkout_response?.paymentWidgetUrl]);
                      this.utilityService.checkIframeInputFocus();
                    }
                  } else {
                    this.paymentService?.checkOutComPayload$?.subscribe((reqData) => {
                      this.checkOutComData = reqData;
                      this.paymentService?.setcheckOutComDocId({ docId: String(this.pathString) });
                      this.isCheckoutCom = true;
                      this.isSecureTrading = false;
                      this.isPaymill = false;
                    });
                  }
                },
                (err) => {
                  this.authService.errorHandlerLogs("Error fetching payment document:", err);
                  throw err;
                }
              );
          }
        } catch (e) {
          this.authService.errorHandlerLogs("Error handling payment logic:", e);
          return e;
        }
        if (!this.pathString || this.userId == "null" || this.userId == null || !this.pathString) return;
        try {
          this.catchService.isOnline$
            .pipe(
              switchMap((isOnline) => {
                if (!isOnline) return from(Promise.resolve(null)); // Return an Observable with null if offline

                const syndicateDocRef = doc(
                  this.firestore,
                  `users/${this.userId}/syndicate_request/${this.pathString}`
                );

                // Convert the Promise from getDoc() to an Observable
                return from(getDoc(syndicateDocRef));
              }),
              this.catchService.retryWhen,
              this.catchService.catchOfflineError,
              shareReplay(1)
            )
            .subscribe(
              (snapshot: DocumentSnapshot<DocumentData>) => {
                // Check if snapshot exists before calling data()
                if (!snapshot || !snapshot.exists()) {
                  const purchaseDetail = this.storePaymentData;
                  // Set the checkout.com doc id for future updates from payment widget
                  this.paymentService?.setcheckOutComDocId({ docId: String(this.pathString) });
                  this.isCheckoutCom = true;
                  this.isSecureTrading = false;
                  this.isPaymill = false;
                  // Set the checkout.com doc id for future updates from payment widget
                  this.discountVouchersStatus = !purchaseDetail.offers?.ongoing_flag;
                  if (
                    this.discountVouchersStatus &&
                    !purchaseDetail.isTopUp &&
                    purchaseDetail.page?.toLowerCase() === this.storeString
                  ) {
                    this.fetchDiscountVouchersData();
                  }
                  if (purchaseDetail) {
                    this.purchaseDetail$.next(purchaseDetail);
                    const offers_checkout_description = this.purchaseDetail$?.value?.offers?.checkout_description;
                    if (offers_checkout_description) {
                      this.authService.getDVFromString(offers_checkout_description).then((dvString: string) => {
                        this.checkout_description = dvString;
                      })
                    }
                  }
                  return;
                }

                // Explicitly cast the snapshot's data to the expected type
                let purchaseDetail = snapshot.data() as {
                  add_on?: Data[];
                  offers?: { checkout_description?: string; ongoing_flag?: boolean };
                  upsell_ID?: string;
                  upsell_amt?: number;
                  payment?: string;
                  isTopUp?: boolean;
                  page?: string;
                };
                purchaseDetail = purchaseDetail ?? this.storePaymentData;
                if (purchaseDetail) {
                  purchaseDetail.add_on = purchaseDetail.add_on || [];
                  this.purchaseDetail$.next(purchaseDetail);
                  const offerCheckoutDescription = this.purchaseDetail$.value?.offers?.checkout_description;
                  this.authService.currencyNodeDvData = this.purchaseDetail$.value?.offers;
                  if (offerCheckoutDescription) {
                    this.authService
                      .getDVFromString(offerCheckoutDescription)
                      .then((dvString: string) => {
                        this.checkout_description = dvString;
                      })
                      .catch((error) => {
                        this.authService.errorHandlerLogs("Error fetching checkout description:", error);
                      });
                  }
                  
                  const upsellID = purchaseDetail.upsell_ID;
                  const paymentID = purchaseDetail.payment;
                  const selectedUpsell = purchaseDetail.add_on || [];
                  this.updatedPrizeValue = purchaseDetail.upsell_amt || 0;

                  if (upsellID && paymentID) {
                    this.getUpsellData(upsellID, selectedUpsell);
                  }
                  this.receivedData = purchaseDetail;
                  this.purchaseDetail$.next(purchaseDetail);

                  this.discountVouchersStatus = !purchaseDetail.offers?.ongoing_flag;
                  if (
                    this.discountVouchersStatus &&
                    !purchaseDetail.isTopUp &&
                    purchaseDetail.page?.toLowerCase() === this.storeString
                  ) {
                    this.fetchDiscountVouchersData();
                  }
                }
              },
              (err) => {
                this.authService.errorHandlerLogs("Error fetching syndicate request document:", err);
                throw err;
              }
            );
        } catch (e) {
          this.authService.errorHandlerLogs("Error handling syndicate request logic:", e);
          return e;
        }
      },
      (err) => {
        return err;
      }
    );
    window.addEventListener("beforeunload", this.handleRefresh);
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.sub?.unsubscribe();
    this.customOfferAwardIdSubscription?.unsubscribe();
    window.removeEventListener("beforeunload", this.handleRefresh);
    this.expiryCheckInterval?.unsubscribe();
    // Unsubscribe to prevent memory leaks
    this.generateCheckoutTokenSubscription?.unsubscribe();
    this.getCheckOutComResponseSubscription?.unsubscribe();
    this.cardTokenizedSubject.complete();
    this.checkoutComGatewayService.unmount();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  // this can be used to implement logic which is necessary when the user refreshes the page
  handleRefresh = (): void => {
    this.resetDiscountVoucherHideStatus();
  };

  count = 0;
  load(e, stepper) {
    localStorage.setItem("payType", "add card");
    this.stepperIframe = stepper;
    this.count++;
    if (this.count > 1) {
      this.isPaymentDone = true;
    }
    this.afterNewCardPaymentDoneUpdated(this.stepperIframe);
  }

  afterNewCardPaymentDoneUpdated(stepper) {
    if (!this.paymentReceivedFromCP) {
      this.paymentReceivedFromCP = true;
      this.unsubscribeStatusFromCP$ = new Subject<void>();
      this.unsubscribeStatusFromPayment$ = new Subject<void>();
      this.paymentService
        .getCustomerPurchaseDetailsFromSQL(this.currentNdcSignal())
        .pipe(takeUntil(this.unsubscribeStatusFromCP$))
        .subscribe((data: Data) => {
          if (data) {
            const purchaseDoc = data;
            const processed_status = purchaseDoc.processed_status;
            if (processed_status !== undefined) {
              if (processed_status === 2) {
                this.celebrationAnimationService.setCreditTopupStatus(true);
                this.stepperIndex = 1;
                stepper.selected.completed = true;
                stepper.selected.editable = false;
                this.isPaymentDone = false;
                this.timerOn = false;
                stepper.next();
                const defaultMsg = {
                  message: {
                    line_1: "Payment successful!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle success.png",
                    type: "Success",
                  },
                };
                this.authService.showToastMessage({}, defaultMsg);
                let token = localStorage.getItem("fbToken");
                if (token) {
                  this.manualLogin(token).then(() => {
                    if (purchaseDoc?.api_response?.response?.encrypt_syndicate_id) {
                      this.paymentService.cashPurchaseAddCardSyndicateId$.next(
                        purchaseDoc?.api_response?.response?.encrypt_syndicate_id
                      );
                    }
                    return;
                  });
                }
                this.resetPaymentSubscriptions();
              } else if (processed_status === -1) {
                const defaultMsg = {
                  message: {
                    line_1: "Payment failed, please try again!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage({}, defaultMsg);
                this.addNewCardInProgress = false;
                this.isPaymentDone = false;
                this.count = 0;
                this.paymentReceived = false;
                this.paymentReceivedFromCP = false;
                this.timerOn = false;
                this.resetPaymentSubscriptions();
              }
            }
          }
        });
    }
  }

  resetPaymentSubscriptions(): void {
    this.unsubscribeStatusFromCP$?.next();
    this.unsubscribeStatusFromCP$?.complete();
    this.unsubscribeStatusFromPayment$?.next();
    this.unsubscribeStatusFromPayment$?.complete();
  }

  afterNewCardPaymentDone(stepper): void {
    try {
      if (!this.paymentReceived && localStorage.getItem("d")) {
        this.paymentReceived = true;
        this.paymentReceivedFromCP = true;
        const urlData = JSON.parse(localStorage.getItem("d"));
        localStorage.removeItem("d");
        setTimeout(() => {
          if (!this.pathString || this.userId == "null" || this.userId == null || !this.pathString) return;
          try {
            this.paymentService
              .checkPaymentStatus(urlData?.id, this.paymentMode)
              .pipe(take(1), takeUntil(this.unsubscribeStatusFromPayment$))
              .subscribe(
                (payment_status) => {
                  this.authService.commonUserCheck(() => {
                    this.payment_status = payment_status;
                    if (
                      payment_status?.result.description.search("succeeded") > -1 ||
                      payment_status?.result.description.search("successfully") > -1
                    ) {
                      this.addNewCardInProgress = false;
                      const customOfferToast = localStorage.getItem("custom-offer-toast");
                      if (customOfferToast === "true" && this.customOfferAwardId && this.customOfferAwardId > 0) {
                        this.showCreditIssueToast();
                      }
                      this.celebrationAnimationService.setCreditTopupStatus(true);
                      this.stepperIndex = 1;
                      stepper.selected.completed = true;
                      stepper.selected.editable = false;
                      this.isPaymentDone = false;
                      this.timerOn = false;
                      this.paymentHold = false;
                      stepper.next();
                      this.orderSuccessEvent();
                      this.resetPaymentSubscriptions();
                      //this.snackbar.openSnackBar(payment_status?.result.description, "", "Success", "Success");
                      //this.authService.showToast(payment_status?.result.description ? payment_status?.result.description : "Something went wrong!", "Success", "");
                      const toastCode = this.paymentService.mapPaymentToastCode(payment_status);
                      const fallback = this.paymentService.mapPaymentToastFallback(payment_status);
                      this.toastFacade.showByCode(toastCode, fallback, {
                        journey: "payment",
                        trigger: "manual_login_payment_result",
                        reason_code: this.paymentService.mapPaymentReasonCode(payment_status),
                      });
                      //this.viewTicket(this.purchaseDetail.page);
                      let token = localStorage.getItem("fbToken");
                      if (token) {
                        this.manualLogin(token)
                          .then(() => {
                            this.paymentService
                              .updatePaymentReqAndRes(this.purchaseDetail$.value, this.payment_status)
                              .subscribe((sqlAPICall) => {
                                this.sqlAPICallResponse = sqlAPICall;
                                if (this.sqlAPICallResponse?.response?.encrypt_syndicate_id) {
                                  this.paymentService.cashPurchaseAddCardSyndicateId$.next(
                                    this.sqlAPICallResponse?.response?.encrypt_syndicate_id
                                  );
                                }
                              });
                            return;
                          })
                          .catch((error) => {
                            return error;
                          });
                      }
                      return;
                    }
                    //this.snackbar.openSnackBar(payment_status?.result.description, "", "Error", "Error");
                    /*  this.authService.showToast(payment_status?.result.description ? payment_status?.result.description : "Something went wrong!", "Error", ""); */
                    const toastCode = this.paymentService.mapPaymentToastCode(payment_status);
                    const fallback = this.paymentService.mapPaymentToastFallback(payment_status);
                    this.toastFacade.showByCode(toastCode, fallback, {
                      journey: "payment",
                      trigger: "manual_login_payment_result",
                      reason_code: this.paymentService.mapPaymentReasonCode(payment_status),
                    });
                    this.timerOn = false;
                    this.isPaymentDone = false;
                    this.paymentHold = false;
                    this.paymentReceived = false;
                    this.paymentReceivedFromCP = false;
                    this.resetPaymentSubscriptions();
                    // redirect to previous page as user has cancelled payment
                    this.redirectToPreviousPage();
                  });
                },
                (err) => {
                  this.isPaymentDone = false;
                  this.paymentReceived = false;
                  this.paymentReceivedFromCP = false;
                  this.paymentHold = false;
                  this.resetPaymentSubscriptions();
                  return err;
                }
              );
          } catch (e) {
            this.paymentReceived = false;
            this.paymentReceivedFromCP = false;
            this.paymentHold = false;
            this.resetPaymentSubscriptions();
            return e;
          }
        }, 1000);
      }
    } catch (e) {
      return e;
    }
  }

  private manualLogin(token: string): Promise<Data> {
    return new Promise((resolve, reject) => {
      this.tokenValidaterSub = this.authService.getV2CloudFunction("tokenvalidater", { token }).subscribe({
        next: async (res) => {
          const { status, token, token_refresh } = res;
          if (status && token) {
            if (token_refresh) {
              localStorage.setItem(this.fbTokenKey, token);
            }
            this.angularFireAuth
              .signInWithCustomToken(token)
              .then(() => {
                this.angularFireAuth.currentUser.then((user) => {
                  if (user) {
                    resolve(user); // Resolves with the authenticated user
                  } else {
                    const defaultMsg = {
                      message: {
                        line_1: "Something went wrong!",
                        line_2: "",
                      },
                      style: {
                        icon: "tick circle error.svg",
                        type: "Error",
                      },
                    };
                    this.authService.showToastMessage({}, defaultMsg);
                    reject(new Error("User is null."));
                  }
                });
              })
              .catch((error) => {
                const logData = {
                  creation_date: new Date(),
                  local_fb_token: localStorage.getItem(this.fbTokenKey) || "Missing Token",
                  error,
                  page: "add-card.component.ts",
                  userId: this.userId || "Missing User ID",
                };
                // Log the error to Firestore
                const path_id = "hbqZtgNd5muQnA8eI3xe";
                const doc_data = logData;
                const method = "create";

                this.authService.getV2CloudFunction("updatefirestoredoc", {
                  path_id,
                  doc_data,
                  method,
                }).subscribe({
                  error: (error) => {
                    this.authService.errorHandlerLogs("Error updating manualLoginPayment list:", error);
                    return false;
                  }
                });
                reject(error); // Rejects the promise with the caught error
              });
          }
        },
        error: (error) => {
          this.authService.errorHandlerLogs("Error in token validation:", error);
          reject(error); // Propagates the error
        },
      });
    });
  }

  viewTicket(page: string): void {
    this.postPaymentNavigationService.viewTicket(this as unknown as PostPaymentHostBridge, page);
  }

  fetchSyndicateAndShowTicket(): void {
    this.postPaymentNavigationService.fetchSyndicateAndShowTicket(this as unknown as PostPaymentHostBridge);
  }

  getPwasegementData() {
    this.commonService.getUid("PwasegementData")
      .pipe(
        take(1),
        switchMap(async (uid: string) => {
          if (!uid) {
            return null;
          }
          const userDocPath = `users/${uid}`;
          try {
            const userSnap = await getDoc(doc(this.firestore, userDocPath));
            if (!userSnap.exists()) {
              return null;
            }
            const userData = userSnap.data();
            this.pwaSegmentStatus = userData?.['pwa_segment_status'];
            return uid;
          } catch (err) {
            return null;
          }
        })
      )
      .subscribe({
        next: (uid) => {
          if (!uid) return;

          this.commonService.slide$
            .pipe(take(1), takeUntil(this.destroy$))
            .subscribe(async (slide) => {
              if (!slide) return;
              this.isOneOff = slide?.isOneOff ?? false;
              this.offerId = slide?.slide_info?.offer_id;
              this.exit_offer_id = slide?.exit_offer_id;
              const offerCappingPath = `users/${uid}/offer_capping/${this.exit_offer_id}`;

              const snap = await getDoc(doc(this.firestore, offerCappingPath));
              if (snap.exists()) {
                const data = snap.data();
                this.capping_status = data?.capping_status ?? false;
              }
            });
        },

        error: (err) => {
          return err;
        }
      });
  }
  openConfirmationPopup() {
    const confirmationDialog = this.matDialog.open(CheckoutConfirmationComponent, {
      panelClass: "mysterybox-dialog-size",
      backdropClass: "mysterybox-back-drop-color",
      hasBackdrop: true,
      disableClose: false,
    });

    confirmationDialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response: boolean) => {
          // We are going back to previous page if the user selects that he is not interested.
          if (response) {
            this.goBack();
          }
        },
        error: (error) => {
          return error;
        },
      });
  }

  handleExitIntentPopup() {
    const paymentParam = this.actRoute.snapshot.queryParamMap.get('offer_applied') === 'true';
    if (
      paymentParam ||
      this.storePaymentData?.isStoreOffer ||
      this.isOneOff ||
      this.storePaymentData?.page === 'store' ||
      this.pwaSegmentStatus === 'subscriber' ||
      this.capping_status === true
    ) {
      this.openConfirmationPopup();
    } else {
      this.openExitIntentPopup(this.exit_offer_id);
    }
  }


  openExitIntentPopup(offerid: number) {
    const confirmationDialog = this.matDialog.open(ExitIntentPopup, {
      panelClass: "mysterybox-dialog-size",
      backdropClass: "mysterybox-back-drop-color",
      hasBackdrop: true,
      disableClose: false,
      data: { offerId: offerid }
    });

    confirmationDialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response: boolean) => {
          if (response) {
            this.goBack();
          }
        },
        error: (error) => {
          return error;
        },
      });
  }

  goBack() {
    this.resetDiscountVoucherHideStatus();
    this.voucherService.updateDiscountVoucherHideStatus(this.selectedDiscountVoucherData?.id, false);
    this.storeService.customOfferCashBackText$.next("");
    this.storeService.customOfferAwardId$.next(0);
    this.storeService.userBackout$.next(true);
    this.location.back();
  }
  async timer(remaining) {
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;

    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    // document.getElementById("timer").innerHTML = m + ":" + s;
    if (this.timerspan) {
      this.timerspan.nativeElement.innerHTML = m + ":" + s;
    }
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      this.timeoutId = setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    this.timeOut = true;
    // this.addingCard = false;
    this.addNewCardInProgress = false;
    // this.showAddNewCard = true;
    //this.authService.showToast("Session timeout has occur, Please try again!", "Error", "");
    this.authService
      .getConstantsMsg("1100")
      .then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Session timeout has occur, Please try again!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      })
      .catch((err) => {
        return err;
      });

    if (this.storePaymentData) {
      const modal = await this.modalController.create({
        component: StorePaymentComponent,
        componentProps: {
          data: this.storePaymentData,
        },
      });
      modal
        .present()
        .then(() => {
          this.location.back();
          return;
        })
        .catch((error) => {
          return error;
        });
    }

    //alert("Timeout for otp");
  }
  private showCreditIssueToast(): void {
    const userId = this.userId;
    const awardId = this.customOfferAwardId;
    localStorage.removeItem("custom-offer-toast");
    this.authService.customOfferCreditCheck(userId, awardId).subscribe(
      (res) => {
        if (res?.status == "success") {
          this.authService
            .getConstantsMsg("1114")
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Credit issued to your account",
                  line_2: "",
                },
                style: {
                  duration: 2000,
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService?.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
        }
      },
      (err) => {
        return err;
      }
    );
  }
  public ngAfterViewInit(): void {
    this.isButtonDisabled = true;

    this.authService?.selectedlanguage$?.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(
      (l) => {
        const lang = l ? l : "en";

        switch (lang) {
          case "en":
            this.language = "EN-GB";
            break;
          case "de":
            this.language = "DE-DE";
            break;
          case "es":
            this.language = "ES-ES";
            break;
          case "fr":
            this.language = "FR-FR";
            break;
          case "it":
            this.language = "IT-IT";
            break;
          default:
            this.language = "EN-GB";
        }
      },
      (err) => {
        this.language = "EN-GB";
        return err;
      }
    );
    const queryParams = this.actRoute.snapshot.queryParams || {};
    this.checkoutComGatewayService.loadCheckoutApiAndInitialize(
      this as unknown as CheckoutTryAgainHostContext,
      queryParams,
      this.actRoute,
    );
  }

  public initializeFrames(): void {
    this.checkoutComGatewayService.initializeFrames(this as unknown as CheckoutTryAgainHostContext);
  }

  /**
   * Flow session amount is fixed at create time — remount so the charged amount matches the selected discount.
   */
  private remountCheckoutFlowForDiscountChange(previousDiscountValue: number, nextDiscountValue: number): void {
    if (
      this.cardTokenizedCalled ||
      this.addNewCardInProgress ||
      !this.keys?.publicKey ||
      nextDiscountValue === previousDiscountValue
    ) {
      return;
    }
    void this.initializeFrames();
  }

  public onSubmit(event: Event): void {
    this.checkoutComGatewayService.onSubmit(this as unknown as CheckoutTryAgainHostContext, event);
  }

  public isCheckoutLoadingMessage(message: string): boolean {
    return this.checkoutComGatewayService.isCheckoutLoadingMessage(message);
  }

  /**
   * Handles the order success event by collecting relevant data and sending it to GTM.
   */
  orderSuccessEvent() {
    const journeyId = parseInt(localStorage.getItem("journeyId") || "0", 10);
    const payType = localStorage.getItem("payType") || "";
    const startTime = new Date().getTime();
    const endTime = new Date().getTime();
    const dwellTime = endTime - startTime;
    const formattedDwellTime = this.AuthSyndicateService.convertMillisecondsToTime(dwellTime);
    const destinationUrl =
      payType === "cash"
        ? `${window.location.origin}/mainTabs/tabs/syndicate`
        : payType === "cash-issue"
          ? `${window.location.origin}/mainTabs/tabs/store`
          : `${window.location.origin}/mainTabs/tabs/syndicate`;
    const eventBody = {
      Lottery_Product: this.receivedData?.real_name || "",
      Dwell_Time: formattedDwellTime,
      Payment_Method: this.receivedData?.offers?.payment_type || "",
      Draw_Days: this.receivedData?.offers?.draw_day || "",
      Line_Count: this.receivedData?.offers?.lines || 0,
      Total_Amount: this.receivedData?.offers?.price || 0,
      Journey_ID: journeyId,
      For_how_many_weeks:
        this.receivedData?.selectedDiscount?.title === "No extension"
          ? "Only once"
          : this.receivedData?.selectedDiscount?.title || "",
      Extension_Period: this.receivedData?.selectedDiscount?.title || "",
      Pre_Existing_Card: "No",
      CTA: "Pay now",
      P_Type: this.receivedData?.p_type || "",
      Destination_URL: destinationUrl,
    };
    this.mixPanelService.salesGerneryMixpanel("Store Organic Cash", eventBody);
    this.mixPanelService.GTMPopupInitializationForInboxNew("Order Success", eventBody);
  }

  private getCookie(name) {
    try {
      var nameEQ = name + "=";
      var cookie = document.cookie?.split(";");
      for (var i = 0; i < cookie.length; i++) {
        var c = cookie[i];
        while (c.charAt(0) == " ") c = c?.substring(1, c.length);
        if (c?.indexOf(nameEQ) == 0) return c?.substring(nameEQ.length, c.length);
      }
      return null;
    } catch (e) {
      return e;
    }
  }
  // get upsell data
  getUpsellData(upsell_ID: string, selectedUpsells?: Data) {
    try {
      this.paymentService.getUpsellList(upsell_ID).subscribe((data) => {
        if (data?.upsell_list) {
          const upsellData = data?.upsell_list;

          // Add isChecked property
          this.upsellList = upsellData.map((value) => {
            if (selectedUpsells.some((upsell) => upsell.offer_id === value.offer_id)) {
              value.isChecked = true;
            } else {
              value.isChecked = false;
            }
            return value;
          });
        }
      });
    } catch (error) {
      return error;
    }
  }

  // on checkbox change
  checkBoxChanged(event: Data, offerData: Data) {
    const isChecked = event?.detail?.checked;
    const prizeValue = event?.detail?.value;
    const prizeValueDefault = offerData?.price["GBP"];

    if (isChecked) {
      // If the checkbox is checked, add the calculated additionOfPrize to the array of checkedValues

      this.checkedValues.push(prizeValue);
      this.checkedValuesDefaultCurrency.push(prizeValueDefault);

      this.addonAmount.push({
        offer_id: offerData.offer_id,
        value: offerData.price["GBP"],
        product_description: offerData?.product_description || "offer",
        preferred_currency: {
          Value: offerData.price[this.preferredCurrency],
          currency: this.preferredCurrency,
        },
      });
      this.upsellSummaryArray.push({
        offer_id: offerData.offer_id ?? "",
        summary_content: offerData?.summary_content ?? {},
        product_description: offerData?.product_description || "offer",
      });
      const purchaseDetail = { ...this.purchaseDetail$.value, add_on: this.addonAmount };
      this.purchaseDetail$.next(purchaseDetail);
    } else {
      // If the checkbox is unchecked, remove the original prizeValue from the array of checkedValues
      const index = this.checkedValues.indexOf(prizeValue);
      if (index !== -1) {
        this.checkedValues.splice(index, 1);
        this.checkedValuesDefaultCurrency?.splice(index, 1);
      }
      const offerIdToRemove = offerData?.offer_id;
      this.addonAmount = this.addonAmount?.filter((addon) => addon?.offer_id !== offerIdToRemove);
      this.upsellSummaryArray = this.upsellSummaryArray?.filter((addon) => addon?.offer_id !== offerIdToRemove);
      const purchaseDetail = { ...this.purchaseDetail$.value, add_on: this.addonAmount };
      this.purchaseDetail$.next(purchaseDetail);
    }
    // Calculate the total prize by summing the values of all checked checkboxes
    const totalPrizeValues = this.checkedValues?.reduce((acc, currentValue) => acc + Number(currentValue), 0);
    this.totalAmount = totalPrizeValues;
    const totalPrize = Number(totalPrizeValues.toFixed(2));
    this.updatedPrizeValue = totalPrize;
  }

  private async unloadPaymentWidget(): Promise<void> {
    try {
      if (window.wpwl !== undefined && window.wpwl?.unload !== undefined) {
        await window.wpwl.unload();

        // Remove scripts using Renderer2
        const scripts = document.querySelectorAll('script[src*="static.min.js"]');
        scripts.forEach((script) => {
          this.renderer.removeChild(document.body, script);
        });
      }
    } catch (error) {
      return error; // Rethrow the error for proper handling
    }
  }

  cardOfferDisabled(index: number) {
    return this.activeCardIndex.includes(index);
  }

  storeSliderOptions2: SwiperOptions = {
    speed: 500,
    slidesPerView: 1.15,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination-2",
      clickable: true,
    },
    // Disabled: slides contain CTA buttons that navigate away. Swiper's rAF callback races
    // with ionViewWillLeave(), leaving params undefined. Explicit false prevents regressions
    // if Swiper defaults or shared configs change. LOTTOSOCIAL-PWA-1NCK
    slideToClickedSlide: false,
    autoplay: {
      delay: 5000,
    },
  };

  slides: Swiper;
  interval;
  setSwiperInstance(swiper) {
    this.slides = swiper;

    // Clear any existing intervals
    clearInterval(this.interval);

    // Start a new interval after a delay to check and control autoplay
    setTimeout(() => {
      this.interval = setInterval(() => {
        // Check if slides or autoplay is undefined
        if (!this.slides || !this.slides.autoplay) {
          return;
        }

        if (!this.autoSlide) {
          // If autoSlide is false, stop autoplay
          this.slides?.autoplay?.stop();
        } else {
          // If autoSlide is true, start or resume autoplay
          this.slides.slideNext(this.speed);
          this.slides.autoplay.start();
        }
      }, 4500);
    }, 4500);
  }

  prev() {
    try {
      this.slider?.swiperRef?.slidePrev(500);
    } catch (e) {
      return e;
    }
  }

  next() {
    try {
      this.slider?.swiperRef?.slideNext(500);
    } catch (e) {
      return e;
    }
  }
  cardOfferPayment(item: Data, index: number) {
    this.cardOfferPaymentService.cardOfferPayment(item, index);
  }

  getCheckCardDetailId() {
    return this.cardOfferPaymentService.getCheckCardDetailId();
  }

  stopSpinner() {
    this.cardOfferPaymentService.stopSpinner();
  }

  //this fucnction is used to process payments for the confirmation page card offers
  cardofferProceedToPay(index: number) {
    this.cardOfferPaymentService.cardofferProceedToPay(index);
  }

  startCountdown() {
    this.cardOfferPaymentService.startCountdown();
  }

  async fetchOrderData() {
    await this.cardOfferPaymentService.fetchOrderData();
  }

  loadCards() {
    const loadCardSub = this.walletService?.paymentDetails$?.subscribe((data) => {
      this.initilizEvent(data);
      this.storedCards = data;
      if (this.storedCards?.length > 0) {
        let withPriority = this.storedCards.filter((card) => card.hasOwnProperty("priority"));
        let withoutPriority = this.storedCards.filter((card) => !card.hasOwnProperty("priority"));
        withPriority.sort((a, b) => b.priority - a.priority);
        this.storedCards = [...withPriority, ...withoutPriority];
        const latestCard = this.storedCards.reduce(
          (latest, card) => {
            const cardDate = new Date(card.date_created);
            return cardDate > latest.date_created ? { ...card, date_created: cardDate } : latest;
          },
          { date_created: new Date(0) }
        ); // Start with an object having the earliest possible date

        this.latestCardData = latestCard;
        if (!this.storedCards.some((card) => card?.isChecked === true)) {
          this.storedCards[0].isChecked = true;
        }
      }
      if (this.storedCards.length > 2) {
        this.showAll = false;
      }
    });
    this.sub?.add(loadCardSub);
  }

  initilizEvent(data) {
    // Handle null/undefined data gracefully
    if (!data || !Array.isArray(data)) {
      data = [];
    }

    const startTime = new Date();
    const endTime = new Date();
    const dwellTime = endTime.getTime() - startTime.getTime();
    const formattedDwellTime = this.AuthSyndicateService.convertMillisecondsToTime(dwellTime);

    this.cardArrlength = data.length;

    const eventBody = {
      Lottery_Product: this.data?.real_name || "",
      Dwell_Time: formattedDwellTime,
      Payment_Method: this.data?.offers?.payment_type || "",
      Draw_Days: this.data?.offers?.draw_day || "",
      Line_Count: this.data?.offers?.lines || 0,
      Total_Amount: this.data?.offers?.price || 0,
      Journey_ID: this.journeyId,
      For_how_many_weeks:
        this.data?.selectedDiscount?.title === "No extension" ? "Only once" : this.data?.selectedDiscount?.title || "",
      Extension_Period: this.data?.selectedDiscount?.title || "",
      Pre_Existing_Card: data.length ? "Yes" : "No",
      Offer_ID: this.data?.offers?.offerid ?? "",
    };

    this.mixPanelService.GTMPopupInitializationForInboxNew("Checkout Popup Viewed", eventBody);
  }

  /**
   * The function `redirectToPreviousPage` retrieves the previous page from the server and navigates to
   * it using Angular Router, falling back to a default URL if there is an error or no previous page is
   * found.
   */
  redirectToPreviousPage(): void {
    this.storeService
      ?.getPreviousPageFromServer()
      ?.pipe(take(1))
      ?.subscribe({
        next: (value) => {
          if (value) {
            this.router.navigateByUrl(`${value}`);
          } else {
            this.router.navigateByUrl(this.storeTabUrl);
          }
        },
        error: (error) => {
          this.router.navigateByUrl(this.storeTabUrl);
          return error;
        },
      });
  }

  private fetchDiscountVouchersData() {
    this.voucherManagementService.fetchDiscountVouchersData(this.purchaseDetail$);
  }

  private startDiscountVouchersExpiryCheck() {
    this.voucherManagementService.startDiscountVouchersExpiryCheck();
  }

  onVoucherSelect(selectedVoucher: Data) {
    this.voucherManagementService.onVoucherSelect(selectedVoucher);
  }

  private resetDiscountVoucherHideStatus() {
    this.voucherManagementService.resetDiscountVoucherHideStatus();
  }

  private resetDiscountAmountOnVoucherExpiry(voucher: Data): void {
    this.voucherManagementService.resetDiscountAmountOnVoucherExpiry(voucher);
  }

  private resetVouchersUI() {
    this.voucherManagementService.resetVouchersUI(this.purchaseDetail);
  }

  private updateExpiryTextInVoucher(expiredVoucher: Data): void {
    this.voucherManagementService.updateExpiryTextInVoucher(expiredVoucher);
  }

  // Event handlers for UpsellAddonsComponent
  onAddonChanged(event: { event: any; offerData: any }) {
    this.checkBoxChanged(event.event, event.offerData);
  }

  // Event handlers for VouchersSliderComponent
  onVoucherSelected(emiteData) {
    this.onVoucherSelect(emiteData);
  }

  // Event handlers for ConfirmationPromotionsComponent
  onOfferPayment(event: { item: any; index: number }) {
    this.cardOfferPayment(event.item, event.index);
  }
}
